import { useContext } from 'react';
import { DragPreviewContext } from '@/pages/Editor/components/tree/dragPreviewContext.ts';

export function useIsDragPreview(): boolean {
  return useContext(DragPreviewContext);
}
